(() => {
  if (window.__bnLearningHubRuntimeV1) return;
  window.__bnLearningHubRuntimeV1 = true;
  'use strict';

  const runtimes = new WeakMap();

  const safeStorageGet = (key) => {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
  };

  const initHub = (hub) => {
    if (!hub || hub.dataset.bnLearningMounted === 'true') return;
    hub.dataset.bnLearningMounted = 'true';
    const controller = new AbortController();
    const { signal } = controller;
    let observer = null;

    const navLinks = Array.from(hub.querySelectorAll('.bn-learning-hub__sidebar a[href^="#bn-learning-block-"]'));
    const sections = navLinks
      .map((link) => hub.querySelector(link.getAttribute('href')))
      .filter(Boolean);

    if ('IntersectionObserver' in window && navLinks.length && sections.length) {
      const setCurrent = (id) => {
        navLinks.forEach((link) => {
          if (link.getAttribute('href') === `#${id}`) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };

      observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible?.target?.id) setCurrent(visible.target.id);
      }, { rootMargin: '-18% 0px -62% 0px', threshold: [0.12, 0.3, 0.55] });

      sections.forEach((section) => observer.observe(section));
    }

    hub.querySelectorAll('.bn-learning-hub__checklist span').forEach((item, index) => {
      if (item.dataset.bnChecklistMounted === 'true') return;
      item.dataset.bnChecklistMounted = 'true';

      const key = `bn_learning_check_${window.location.pathname}_${index}_${item.textContent.trim().slice(0, 40)}`;
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-pressed', safeStorageGet(key) === 'true' ? 'true' : 'false');
      item.dataset.bnChecked = item.getAttribute('aria-pressed');

      const toggle = () => {
        const next = item.getAttribute('aria-pressed') !== 'true';
        item.setAttribute('aria-pressed', String(next));
        item.dataset.bnChecked = String(next);
        try { window.localStorage.setItem(key, String(next)); } catch (error) {}
      };

      item.addEventListener('click', toggle, { signal });
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      }, { signal });
    });

    runtimes.set(hub, {
      destroy() {
        controller.abort();
        observer?.disconnect();
        hub.querySelectorAll('.bn-learning-hub__checklist span').forEach((item) => {
          delete item.dataset.bnChecklistMounted;
        });
        delete hub.dataset.bnLearningMounted;
        runtimes.delete(hub);
      },
    });
  };

  const init = () => document.querySelectorAll('[data-bn-learning-hub]').forEach(initHub);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    const scope = event.target;
    const hubs = [];
    if (scope?.matches?.('[data-bn-learning-hub]')) hubs.push(scope);
    scope?.querySelectorAll?.('[data-bn-learning-hub]').forEach((hub) => hubs.push(hub));
    hubs.forEach((hub) => runtimes.get(hub)?.destroy());
  });
})();
